exports.f = Object.getOwnPropertySymbols;



//////////////////
// WEBPACK FOOTER
// /Users/chad/Developer/shelfmaid-abel/site/~/core-js/modules/_object-gops.js
// module id = ../../../../core-js/modules/_object-gops.js
// module chunks = 0